export default __webpack_public_path__ + "static/media/13.46e8614d.jpg";